import { Builder } from '@builder.io/react'
import { HeadingClass, HeadingType } from 'enums'
import React from 'react'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  imageSrc: any
  imageEnabled: boolean
  headingText: string
  headingTextColor: string
  subText: string
  subTextColor: string
  backgroundOverlayColor: string
  optionalBackgroundOverlayColorButton: boolean
  textAlignment: Alignment
  headingType: HeadingType
  headingClass: HeadingClass
  imageAltText: string
}

const TextOnColorBg = ({
  backgroundColor,
  imageSrc,
  backgroundOverlayColor,
  optionalBackgroundOverlayColorButton,
  headingText,
  headingTextColor,
  subText,
  subTextColor,
  textAlignment,
  imageEnabled,
  headingType,
  headingClass,
  imageAltText = ''
}: Props) => {
  const renderImage = () => {
    if (!imageEnabled) return null

    return (
      <img
        src={
          imageSrc ||
          'https://images.unsplash.com/photo-1601381718415-a05fb0a261f3?ixid=MXwxMjA3fDB8MHxwcm9maWxlLXBhZ2V8ODl8fHxlbnwwfHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1216&q=80'
        }
        alt={imageAltText}
        className="h-full w-full object-cover"
      />
    )
  }

  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const textAlignClass = getAlignmentClass()

  return (
    <div className="bg-white py-8 lg:py-8" style={{ backgroundColor: backgroundColor }}>
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* lg:grid lg:grid-cols-2 lg:gap-x-8 */}
        <div
          className="relative overflow-hidden py-24 px-8 lg:px-16 "
          style={{ backgroundColor: optionalBackgroundOverlayColorButton ? backgroundOverlayColor : 'transparent' }}
        >
          <div className="absolute inset-0 opacity-50 mix-blend-multiply saturate-0 filter">{renderImage()}</div>
          <div className={`relative lg:col-span-1 ${textAlignClass}`}>
            {/* heading should be here */}
            <CustomHeading
              classList="font-bold tracking-tight text-gray-900"
              headingClass={headingClass}
              headingType={headingType}
              color={headingTextColor}
            >
              {headingText}
            </CustomHeading>
            {/* <p className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl" style={{ color: headingTextColor }}>{headingText}</p> */}
            <blockquote className="mt-6 text-white">
              <p className="font-small text-xl sm:text-2xl" style={{ color: subTextColor }}>
                {subText}
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextOnColorBg

Builder.registerComponent(TextOnColorBg, {
  name: 'TextWithColorBackground',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'imageSrc',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Main Text'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'subText',
      type: 'text',
      defaultValue: 'Sub Text'
    },
    {
      name: 'subTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'backgroundOverlayColor',
      type: 'color',
      defaultValue: 'blue'
    },
    {
      name: 'optionalBackgroundOverlayColorButton',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    }
  ]
})
